<template>
  <k-container
    class="tw-transition-colors tw-duration-200"
    :class="{ 'tw-bg-white tw-text-gray-900': variant === 'light', 'tw-bg-gray-900 tw-text-white': variant === 'dark' }"
  >
    <nav
      aria-label="Primárna navigácia"
      class="tw-transition-colors tw-duration-200 navigation-wrapper"
    >
      <div class="tw-flex tw-items-center tw-space-x-6">
        <k-link
          :to="{ name: $data.$ROUTE_NAMES.HOME }"
          :class="{ 'tw-text-gray-700': variant === 'light', 'tw-text-white': variant === 'dark' }"
        >
          <k-logo class="tw-h-10 sm:tw-h-12 tw-object-left" />
        </k-link>

        <div class="tw-hidden xl:tw-flex tw-items-center">
          <k-link
            v-for="(link, idx) in primaryLinks"
            :to="link.to"
            :key="idx"
            class="tw-py-0.5 tw-px-3 tw-rounded-md tw-mr-2 tw-text-base tw-leading-relaxed tw-font-medium tw-transition-colors tw-duration-200 tw-bg-transparent"
            :class="{ 'tw-text-gray-800, hover:tw-bg-gray-100': variant === 'light', 'tw-text-white': variant === 'dark' }"
            type="other"
          >
            {{ link.title }}
          </k-link>

          <k-menu :label="$t('global.actions.more')" label-class="hover:tw-bg-gray-100">
            <k-link
              v-for="(link, idx) in moreLinks"
              :key="idx"
              :to="link.to"
              class="tw-text-gray-800 tw-text-base tw-leading-7 tw-no-underline hover:tw-text-gray-500"
            >
              {{ link.title }}
            </k-link>
          </k-menu>
        </div>
      </div>

      <div class="xl:tw-hidden">
        <v-btn icon @click="$emit('open-drawer')">
          <k-icon name="menu" class="tw-text-gray-700" />
        </v-btn>
      </div>

      <div class="tw-hidden xl:tw-flex tw-flex tw-items-center">
        <k-language-nav-switcher v-if="!profile" class="tw-mr-2" label-class="language-switch-label" />

        <span class="tw-relative">
          <span
            class="tw-top-1/2 tw-left-0 tw-transform tw--translate-y-1/2 tw-h-6 tw-absolute"
            :class="{ 'tw-border-gray-100': variant === 'light', 'tw-border-gray-700': variant === 'dark', 'tw-border-l': !profile }"
          ></span>
        </span>

        <k-nav-user
          style="isolation: isolate"
          class="tw-z-20 tw-relative tw-ml-6"
          @open-drawer="$emit('open-drawer')" :variant="variant"
        />
      </div>
    </nav>
    <slot></slot>
  </k-container>
</template>

<script>
import KLanguageNavSwitcher from '@web/components/core/k-language-nav-switcher'
import KNavUser from '@web/components/core/k-nav-user'
import KMenu from '@web/components/core/k-menu'
import { mapGetters } from 'vuex'

export default {
  components: { KMenu, KNavUser, KLanguageNavSwitcher },
  props: {
    hasBorder: {
      type: Boolean,
      default: true,
    },
    scrolled: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'light',
      validator: function (value) {
        return ['light', 'dark'].indexOf(value) !== -1
      },
    },
  },
  computed: {
    ...mapGetters({
      profile: 'USER/getUserProfile',
    }),
    primaryLinks() {
      return [
        {
          title: this.$t('navigation.jobs'),
          to: {
            name: this.$data.$ROUTE_NAMES.PROJECT_INDEX,
          },
        },
        {
          title: this.$t('navigation.companies'),
          to: {
            name: this.$data.$ROUTE_NAMES.COMPANY_SERVICES,
          },
        },
        {
          title: this.$t('navigation.about_us'),
          to: {
            name: this.$data.$ROUTE_NAMES.ABOUT_US,
          },
        },
        {
          title: this.$t('navigation.contact_us'),
          to: {
            name: this.$data.$ROUTE_NAMES.ABOUT_US,
            hash: '#contact',
          },
        },
      ]
    },
    moreLinks() {
      return [
        {
          title: this.profile ? this.$t('global.my_resume') : this.$t('global.resume'),
          to: {
            name: this.profile ? this.$data.$ROUTE_NAMES.PROFILE_CV : this.$data.$ROUTE_NAMES.CV_LANDING_PAGE,
          },
        },
        {
          title: this.$t('navigation.adequate_salary'),
          to: {
            name: this.$data.$ROUTE_NAMES.QUESTIONAIRE,
          },
        },
        {
          title: this.$t('navigation.calculator'),
          to: {
            name: this.$data.$ROUTE_NAMES.CALCULATOR,
          },
        },
        {
          title: this.$t('navigation.events'),
          to: {
            name: this.$data.$ROUTE_NAMES.EVENT_INDEX,
          },
        },
        {
          title: this.$t('navigation.koderia_referral'),
          to: {
            name: this.$data.$ROUTE_NAMES.REFERRAL,
          },
        },
        {
          title: this.$t('navigation.koderia_extra'),
          to: {
            name: this.$data.$ROUTE_NAMES.EXTRA,
          },
        },
        {
          title: this.$t('navigation.blog'),
          to: {
            name: this.$data.$ROUTE_NAMES.BLOG_INDEX,
          },
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .language-switch-label {
  font-size: 0.875rem !important;
}

.navigation-wrapper {
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
